import apiSlice from "./ApiSlice";

const CouponApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllCouponData: builder.query({
      providesTags: ["coupon"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/coupon",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteCouponById: builder.mutation({
      invalidatesTags: ["coupon"],
      query: (id: any) => ({
        url: `/coupon/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addCoupon: builder.mutation({
      invalidatesTags: ["coupon"],
      query: (body) => ({
        url: `/coupon/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getCouponById: builder.query({
      providesTags: ["coupon"],
      query: (id: string) => {
        return {
          url: `/coupon/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllCoupon: builder.query({
      providesTags: ["coupon"],
      query: () => {
        return {
          url: `/coupon`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateCouponById: builder.mutation({
      invalidatesTags: ["coupon"],
      query: ({ body, id }) => ({
        url: `/coupon/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusCouponById: builder.mutation({
      invalidatesTags: ["coupon"],
      query: ({ body, id }) => ({
        url: `/coupon/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllCouponDataQuery,
  useDeleteCouponByIdMutation,
  useAddCouponMutation,
  useGetCouponByIdQuery,
  useUpdateCouponByIdMutation,
  useGetAllCouponQuery,
  useChangeStatusCouponByIdMutation,
} = CouponApi;
